import styled from '@emotion/styled';

export const ViewWrapper = styled.div`
  margin-bottom: -7px;
  height: 21px;
  width: fit-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  & > div {
    max-width: calc(100% - ${({ shrink }) => (shrink ? 20 : 0)}px);
  }
`;

export const LinkButtonWrapper = styled.div`
  margin-left: 7px;
  padding-bottom: 7px;
  flex-shrink: 0;
  & > i {
    width: 10px;
  }
  & > button {
    position: static;
  }
`;
